import React, { useEffect, useState } from "react";
import contractService from "../../../services/contractService";
import {
  readTrackedDocumentJobs,
  removeTrackedDocumentJob,
  updateTrackedDocumentJob,
} from "../../../utils/documentJobTracker";
import Icon from "../../../components/AppIcon";

const DocumentActivityStrip = ({ onJobFinished }) => {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    let cancelled = false;

    const tick = async () => {
      const list = readTrackedDocumentJobs();
      if (cancelled) return;
      setJobs(list);

      for (const job of list) {
        if (cancelled) break;
        if (job.status === "PDF_GENERATED" || job.status === "timeout") continue;

        const result = await contractService.getDocumentByJobId(job.jobId);
        if (!result?.success || !result.data) continue;

        const status = result.data.status;
        updateTrackedDocumentJob(job.jobId, { status });

        if (status === "PDF_GENERATED") {
          removeTrackedDocumentJob(job.jobId);
          onJobFinished?.(job.jobId);
        }
      }

      if (!cancelled) {
        setJobs(readTrackedDocumentJobs());
      }
    };

    tick();
    const id = window.setInterval(tick, 4000);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, [onJobFinished]);

  const visible = jobs.filter(
    (j) => j.status !== "PDF_GENERATED" && j.status !== "timeout"
  );

  if (!visible.length) return null;

  return (
    <div className="mb-4 rounded-xl border border-primary/25 bg-primary/5 px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
      <div className="flex items-center gap-2 text-sm font-medium text-foreground">
        <span className="h-2 w-2 rounded-full bg-primary animate-ping" />
        Processando documento
      </div>
      <ul className="flex-1 text-sm text-muted-foreground space-y-1">
        {visible.map((job) => (
          <li key={job.jobId} className="flex items-center justify-between gap-2">
            <span className="truncate">{job.title}</span>
            <span className="text-xs shrink-0 capitalize">
              {job.status === "pending" ? "Na fila…" : job.status || "…"}
            </span>
          </li>
        ))}
      </ul>
      <button
        type="button"
        className="text-xs text-muted-foreground hover:text-foreground inline-flex items-center gap-1"
        onClick={() => {
          visible.forEach((j) => removeTrackedDocumentJob(j.jobId));
          setJobs(readTrackedDocumentJobs());
        }}
      >
        <Icon name="X" size={14} />
        Ocultar
      </button>
    </div>
  );
};

export default DocumentActivityStrip;
